import styled from 'foundations-theming/utils';
import { EditIcon, RemoveIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { ReplyRecommendationCitationsButton } from './citations/ReplyRecommendationCitationsButton';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReplyRecIconTitle = styled.div.withConfig({
  displayName: "ReplyRecommendation__ReplyRecIconTitle",
  componentId: "sc-1ch7498-0"
})(["display:flex;align-items:center;"]);
const ReplyRecButtonContainer = styled.div.withConfig({
  displayName: "ReplyRecommendation__ReplyRecButtonContainer",
  componentId: "sc-1ch7498-1"
})(["display:flex;gap:8px;"]);
const ReplyRecBody = styled.div.withConfig({
  displayName: "ReplyRecommendation__ReplyRecBody",
  componentId: "sc-1ch7498-2"
})(["max-height:58px;overflow:auto;"]);
export const ReplyRecommendation = ({
  onEdit,
  onDismiss,
  currentReplyRecommendation
}) => {
  var _currentReplyRecommen;
  return /*#__PURE__*/_jsxs(View, {
    as: "aside",
    role: "status",
    padding: "200",
    margin: "100",
    borderRadius: "200",
    backgroundColor: "fill-accent-magenta-subtle-alt",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      marginBlockEnd: "200",
      children: [/*#__PURE__*/_jsxs(ReplyRecIconTitle, {
        children: [/*#__PURE__*/_jsx(H2, {
          typography: "heading-50",
          margin: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.reply-recommendations.title"
          })
        }), /*#__PURE__*/_jsx(View, {
          marginInlineStart: "200",
          blockSize: "26px",
          children: /*#__PURE__*/_jsx(AIBadge, {})
        })]
      }), /*#__PURE__*/_jsxs(ReplyRecButtonContainer, {
        children: [/*#__PURE__*/_jsxs(Button, {
          margin: "0",
          size: "extra-small",
          use: "tertiary",
          onClick: onEdit,
          children: [/*#__PURE__*/_jsx(EditIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.reply-recommendations.edit"
          })]
        }), ((_currentReplyRecommen = currentReplyRecommendation.citations) === null || _currentReplyRecommen === void 0 ? void 0 : _currentReplyRecommen.length) > 0 ? /*#__PURE__*/_jsx(ReplyRecommendationCitationsButton, {
          citationsList: currentReplyRecommendation.citations
        }) : null, /*#__PURE__*/_jsx(Button, {
          margin: "0",
          use: "transparent",
          size: "extra-small",
          onClick: onDismiss,
          "aria-label": I18n.text('composer-ui.reply-recommendations.dismiss'),
          children: /*#__PURE__*/_jsx(RemoveIcon, {
            color: "icon-core-subtle"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(ReplyRecBody, {
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: currentReplyRecommendation.richText || currentReplyRecommendation.text
      })
    })]
  });
};
ReplyRecommendation.displayName = 'ReplyRecommendation';